import { render, staticRenderFns } from "./AudienceSocialClass.vue?vue&type=template&id=6a5d0c8f&scoped=true"
import script from "./AudienceSocialClass.vue?vue&type=script&lang=js"
export * from "./AudienceSocialClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d0c8f",
  null
  
)

export default component.exports